function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'leopard': 'url("//alayaswim.com/cdn/shop/files/Leo_120x.png?v=15092875272977679561")','gzhel': 'url("//alayaswim.com/cdn/shop/files/Gzhel_120x.png?v=3905721048127045064")','forest': 'url("//alayaswim.com/cdn/shop/files/Forest_120x.png?v=17450383138221067107")','jungle': 'url("//alayaswim.com/cdn/shop/files/Jungle_120x.png?v=7410937271687828069")','zebra': 'url("//alayaswim.com/cdn/shop/files/Zebra_120x.png?v=9869438109447812394")','peonies': 'url("//alayaswim.com/cdn/shop/files/Peonies_120x.png?v=9236898547759605565")','night-stones': 'url("//alayaswim.com/cdn/shop/files/NightStones_120x.png?v=1093994122220305920")','leopard-2-0': 'url("//alayaswim.com/cdn/shop/files/Leo_2.0_120x.png?v=18219557552888537304")','exotic': 'url("//alayaswim.com/cdn/shop/files/Exotic_120x.png?v=11809056317583013116")','amore': 'url("//alayaswim.com/cdn/shop/files/Amore_120x.png?v=13688074912156599086")','hawai': 'url("//alayaswim.com/cdn/shop/files/Hawai_120x.png?v=10361365319046117249")','art-blue': 'url("//alayaswim.com/cdn/shop/files/Art-blue_120x.png?v=12651614808737221136")','snake': 'url("//alayaswim.com/cdn/shop/files/Snake_120x.png?v=8371622888047688749")','sakura-dragon': 'url("//alayaswim.com/cdn/shop/files/Dragon_120x.png?v=3960187422515056058")','neo-sun': 'url("//alayaswim.com/cdn/shop/files/Neo-sun_120x.png?v=17332807917615673753")','sharks': 'url("//alayaswim.com/cdn/shop/files/Sharks_120x.png?v=15501310785557725693")','tropical': 'url("//alayaswim.com/cdn/shop/files/Tropical_120x.png?v=15603793533908433819")','jaguar': 'url("//alayaswim.com/cdn/shop/files/jaguar_120x.png?v=12690194005295954249")','botany': 'url("//alayaswim.com/cdn/shop/files/botany_120x.png?v=13657158252304927651")','jaguar-white': 'url("//alayaswim.com/cdn/shop/files/jaguar-white_120x.png?v=11350528606777080929")','floral': 'url("//alayaswim.com/cdn/shop/files/floral_120x.png?v=3333136271626655475")','montana': 'url("//alayaswim.com/cdn/shop/files/Montana_120x.png?v=1898407570449715179")','mosaic': 'url("//alayaswim.com/cdn/shop/files/Mosaic_120x.png?v=8371967039571718244")','gipur': 'url("//alayaswim.com/cdn/shop/files/Gipur_120x.png?v=12747444950263549760")','tattoo': 'url("//alayaswim.com/cdn/shop/files/Tattoo_120x.png?v=6585520865581169960")','eden-noir': 'url("//alayaswim.com/cdn/shop/files/Eden-noir_120x.png?v=17248554860639184983")',};

    this.triggers = ['color','цвет','колір','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
